import React, { createContext, useEffect } from 'react'

import { ILivePageProps } from 'plugin-codaf-risk-ext-bowtie/types'
import { DRA_ALARMS } from 'plugin-codaf-risk-ext-bowtie/utils/constants'
import { setParamsBuilder } from 'plugin-codaf-risk-ext-bowtie/utils/setRouteParams'

import { themeAwardWidgetDecorator } from '../utils'
import { BowtieAlarms } from './BowtieAlarms'

export interface IQueryParamsList {
    type: 'list'

    [x: string]: string | number | boolean
}

export interface IQueryParamsEdit {
    type: 'edit'
    id?: number
    new?: boolean
}

export interface IAlarmsRouteContext<P extends IQueryParamsList | IQueryParamsEdit> {
    params: P
    setParams: (newParams: IQueryParamsList | IQueryParamsEdit) => void
}

const defaultParams: IQueryParamsList | IQueryParamsEdit = {
    type: 'list',
    page: 1,
    perPage: 50,
    direction: 'ASC',
    orderBy: 'ID'
}

const setParams = setParamsBuilder(`/#/config/${DRA_ALARMS}`)

export const BowtieAlarmsRouteContext = createContext({
    params: defaultParams,
    setParams
} as IAlarmsRouteContext<any>)

export const BowtieAlarmsWrapper: React.FC<ILivePageProps<IQueryParamsList | IQueryParamsEdit>> = ({ id: params }) => {
    useEffect(() => {
        if (!params || !params.type || (params.type === 'edit' && !params.id && !params.new)) {
            setParams({ ...defaultParams })
        } else {
            if (params.type === 'list') {
                setParams({ ...defaultParams, ...params })
            }
        }
    }, [params])

    return (
        <BowtieAlarmsRouteContext.Provider value={{ params: params ?? defaultParams, setParams: setParams }}>
            <BowtieAlarms />
        </BowtieAlarmsRouteContext.Provider>
    )
}
